import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { urlImagem } from '../lib/api';
import { AtivoConsumo, carregarAtivosComConsumo } from './consumoHelpers';

function formatarDataHora(valor?: string | null): string {
  if (!valor) return 'Sem leitura registrada';
  try {
    return new Date(valor).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return valor;
  }
}

export default function RegistroConsumoLista() {
  const [ativos, setAtivos] = useState<AtivoConsumo[]>([]);
  const [busca, setBusca] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);

  async function carregar() {
    setCarregando(true);
    setErro('');
    try {
      const data = await carregarAtivosComConsumo(true);
      setAtivos(data);
    } catch (e) {
      setErro(e instanceof Error ? e.message : String(e));
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    carregar().catch(() => {});
  }, []);

  const ativosFiltrados = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    if (!termo) return ativos;
    return ativos.filter((ativo) => (
      `${ativo.nome} ${ativo.patrimonio || ''} ${ativo.marca || ''}`.toLowerCase().includes(termo)
    ));
  }, [ativos, busca]);

  return (
    <div>
      <div className="titulo-pg">
        <h1>Registro de consumo</h1>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn sec sm" onClick={() => carregar().catch(() => {})}>Atualizar</button>
          <Link className="btn sec sm" to="/app/consumo">Abrir medidores</Link>
        </div>
      </div>

      {erro && <div className="msg-erro">{erro}</div>}

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginBottom: 12 }}>
          <div>
            <h3 style={{ margin: 0 }}>Equipamentos com consumo vinculado</h3>
            <small style={{ color: 'var(--texto-suave)' }}>
              Selecione um equipamento para abrir a tela de registro do consumo atrelado.
            </small>
          </div>
          <div style={{ minWidth: 260, flex: '1 1 320px' }}>
            <label>Buscar equipamento</label>
            <input
              className="input"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              placeholder="Digite nome, patrimônio ou marca"
            />
          </div>
        </div>
      </div>

      {carregando ? (
        <div className="card"><div className="loading"><div className="loading-orbs"><i /><i /><i /></div><div className="loading-txt">Carregando equipamentos com consumo...</div></div></div>
      ) : (
        <div className="grid cols2">
          {ativosFiltrados.map((ativo) => (
            <div key={ativo.id} className="card">
              <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                {ativo.foto_url ? (
                  <img src={urlImagem(ativo.foto_url)} alt="" className="thumb" />
                ) : (
                  <div style={{ width: 84, height: 84, borderRadius: 12, border: '1px solid var(--cinza-borda)', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--texto-suave)', fontSize: 12, textAlign: 'center', padding: 8 }}>
                    Sem imagem
                  </div>
                )}
                <div style={{ minWidth: 0, flex: 1 }}>
                  <h3 style={{ margin: '0 0 6px' }}>{ativo.nome}</h3>
                  <div style={{ color: 'var(--texto-suave)', fontSize: 13 }}>
                    {ativo.patrimonio || ativo.marca || 'Sem identificação adicional'}
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                    <span className="badge">{ativo.total_medidores} medidor(es)</span>
                    <span className="badge">{ativo.medidores_ativos} ativo(s)</span>
                  </div>
                  <div style={{ color: 'var(--texto-suave)', fontSize: 13, marginTop: 10 }}>
                    Última leitura: {formatarDataHora(ativo.ultima_leitura)}
                  </div>
                </div>
              </div>

              <div className="form-actions" style={{ marginTop: 16 }}>
                <Link className="btn" to={`/app/registro-consumo/${ativo.id}`}>Registrar consumo</Link>
                <Link className="btn sec" to={`/app/consumo`}>Medidores</Link>
              </div>
            </div>
          ))}
          {!ativosFiltrados.length && (
            <div className="card" style={{ gridColumn: '1 / -1' }}>
              <div className="vazio">
                {ativos.length
                  ? 'Nenhum equipamento com consumo corresponde à busca informada.'
                  : 'Nenhum equipamento possui medidor de consumo vinculado no momento.'}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
